import type { ArticleProductLookupState } from '@/lib/article-product-lookup'

/** Editorial context without a price, purchase link, or unsupported stock claim. */
export function ArticleProductUnavailable({ name, imageUrl, state }: {
  name: string
  imageUrl: string
  state: Exclude<ArticleProductLookupState, 'available'>
}) {
  return <section aria-label={`Product information: ${name}`} className="my-6 rounded-xl border border-gray-200 bg-white p-5">
    <div className="flex flex-wrap items-center gap-5">
      {/* The source image remains context; no unavailable PDP link surrounds it. */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={imageUrl} alt={name} width={120} height={120} className="h-28 w-28 shrink-0 object-contain" />
      <div className="min-w-0 flex-1 basis-48">
        <h3 className="text-base font-semibold text-gray-900">{name}</h3>
        <p className="mt-2 text-sm text-gray-600">{state === 'lookup-failed'
          ? 'Product details could not be checked. Please try again.'
          : 'A current product page is unavailable. This product remains mentioned for article context.'}</p>
      </div>
    </div>
  </section>
}
